import styled from 'styled-components'

const evaluationFormWidth = 370

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  margin-bottom: 1rem;
  background-color: transparent;
  gap: 2rem;
  width: 100%;
  min-width: 0;
`

export const TitleText = styled.h1`
  font-weight: 700;
  font-size: 28px;
  line-height: 48px;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
  overflow-wrap: break-word;
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`

export const FormIdeaOuterDiv = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 392px;
  align-items: start;
  column-gap: 1.5rem;
  width: 100%;
  max-width: 100%;
  min-width: 0;

  @media screen and (max-width: 1200px) {
    grid-template-columns: minmax(0, 1fr);
    row-gap: 1.5rem;
  }
`

export const ApplicationColumn = styled.div`
  min-width: 0;
  max-width: 100%;
`

export const ContentContainer = styled.div`
  position: relative;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
`

export const FormIdeaInnerDiv = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 100%;
  padding: 0;
`

export const TabsContainer = styled.div`
  display: flex;
  gap: 0;
  background-color: transparent;
  margin-bottom: 1rem;
`

export const TabItem = styled.div`
  padding: 12px 20px;
  cursor: pointer;
  color: #6c757d;
  font-weight: 500;
  transition: all 0.3s ease;
  background-color: transparent;
  border-bottom: 3px solid transparent;
  
  &:hover {
    color: #0066B3;
    border-bottom: 3px solid #0066B3;
  }
  
  &.active {
    color: #0066B3;
    border-bottom: 3px solid #0066B3;
    font-weight: bold;
  }
`

